var _rect, _rect2, _rect3, _rect4, _g, _rect5, _rect6, _rect7, _rect8, _rect9, _g2, _rect10, _rect11, _rect12, _rect13, _rect14, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWelcomeAsset(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 435,
    height: 343,
    viewBox: "0 0 435 343",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 69,
    width: 281,
    height: 338,
    rx: 4,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 86,
    y: 24,
    width: 217,
    height: 24,
    rx: 12,
    fill: "#E2E8F0"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 86,
    y: 54,
    width: 179,
    height: 11,
    rx: 5.5,
    fill: "#EDF2F7"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 86,
    y: 71,
    width: 115,
    height: 11,
    rx: 5.5,
    fill: "#EDF2F7"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_dd_5878_44254)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 260,
    width: 107,
    height: 57,
    rx: 4,
    fill: "white"
  }))), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 21,
    y: 268,
    width: 78,
    height: 7,
    rx: 3.5,
    fill: "#EDF2F7"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 21,
    y: 279,
    width: 53,
    height: 7,
    rx: 3.5,
    fill: "#EDF2F7"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 21,
    y: 290,
    width: 70,
    height: 7,
    rx: 3.5,
    fill: "#EDF2F7"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 99,
    y: 290,
    width: 12,
    height: 7,
    rx: 3.5,
    fill: "#F16063"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 99,
    y: 279,
    width: 12,
    height: 7,
    rx: 3.5,
    fill: "#4AAE8C"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_dd_5878_44254)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 242,
    y: 173,
    width: 177,
    height: 95,
    rx: 4,
    fill: "white"
  }))), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 251,
    y: 182,
    width: 137,
    height: 12,
    rx: 6,
    fill: "#EDF2F7"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 251,
    y: 201,
    width: 93,
    height: 13,
    rx: 6.5,
    fill: "#EDF2F7"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 251,
    y: 221,
    width: 123,
    height: 12,
    rx: 6,
    fill: "#EDF2F7"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 388,
    y: 221,
    width: 21,
    height: 12,
    rx: 6,
    fill: "url(#paint0_linear_5878_44254)"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 388,
    y: 201,
    width: 21,
    height: 13,
    rx: 6.5,
    fill: "url(#paint1_linear_5878_44254)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_dd_5878_44254",
    x: 0,
    y: 254,
    width: 139,
    height: 89,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 10
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0784314 0 0 0 0 0.145098 0 0 0 0 0.247059 0 0 0 0.06 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_5878_44254"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0470588 0 0 0 0 0.101961 0 0 0 0 0.294118 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_5878_44254",
    result: "effect2_dropShadow_5878_44254"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_5878_44254",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_dd_5878_44254",
    x: 226,
    y: 167,
    width: 209,
    height: 127,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 10
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0784314 0 0 0 0 0.145098 0 0 0 0 0.247059 0 0 0 0.06 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_5878_44254"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0470588 0 0 0 0 0.101961 0 0 0 0 0.294118 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_5878_44254",
    result: "effect2_dropShadow_5878_44254"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_5878_44254",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_5878_44254",
    x1: 409,
    y1: 221,
    x2: 398.662,
    y2: 239.092,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEF5E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F7936F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_5878_44254",
    x1: 409,
    y1: 201,
    x2: 397.364,
    y2: 219.797,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D665FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4C6FFF"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWelcomeAsset);
export default __webpack_public_path__ + "static/media/welcome-asset.6f0dad0fa0caa4ae21f93fa9e6d248b0.svg";
export { ForwardRef as ReactComponent };